import { RequestHelper } from 'utils';
import { API_ROUTES } from 'utils/constants';

// GET

// POST
const logStackTrace = ({ stackTrace, body }) => RequestHelper.POST(API_ROUTES.LOG_ERRORS, { stackTrace, body });

export const LogService = {
  logStackTrace
};
